// src/Components/Forms/Financement/Salam/Reception/Tab3.tsx
import React from 'react';
import { Box } from '@mui/material';
import { Spin } from 'antd';
import Table from '../../../../TableResizable';
import { ColumnsType } from 'antd/es/table';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';

interface Tab3Props {
  data: any[];
  loading?: boolean;
}

const Tab3: React.FC<Tab3Props> = ({ data, loading = false }) => {
  const columns: ColumnsType<any> = [
    { title: 'N° Livraison', dataIndex: 'NumeroLivraison' },
    {
      title: 'Date Livraison',
      dataIndex: 'DateLivraisonEffective',
      render: (v) => (v ? new Date(v).toLocaleDateString('fr') : ''),
    },
    { title: 'Quantité', dataIndex: 'QuantiteLivre', render: (v) => formatNumber(v) },
    { title: 'Prix Unitaire', dataIndex: 'PrixUnitaire', render: (v) => formatNumber(v) },
    { title: 'Valeur', dataIndex: 'ValeurLivraison', render: (v) => formatNumber(v) },
    { title: 'Lieu', dataIndex: 'LieuLivraison' },
    { title: 'Conforme', dataIndex: 'Conforme', render: (v) => (v ? 'Oui' : 'Non') },
    { title: 'Bordereau', dataIndex: 'ReferenceBordereau' },
    { title: 'Observations', dataIndex: 'Observations' },
    { title: 'Créé par', dataIndex: 'CreePar' },
  ];

  return (
    <div className="tabItem">
      <Box fontStyle="inherit" className="border" width={'85%'} position={'absolute'}>
        <Spin spinning={loading}>
          <Table
            size="small"
            columns={columns}
            dataSource={data}
            scroll={{ y: 200 }}
            pagination={false}
            rowKey="NumeroLivraison"
          />
        </Spin>
      </Box>
    </div>
  );
};

export default Tab3;